import { render, staticRenderFns } from "./NewChatCommonList.vue?vue&type=template&id=b23291ca"
import script from "./NewChatCommonList.vue?vue&type=script&lang=js"
export * from "./NewChatCommonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports